import React from 'react';
import { StyleSheet, View } from 'react-native';
import { CheckBox } from '@ui-kitten/components';
import PropTypes from 'prop-types';

import withFormik from '../../Hooks/withFormik';
import ThemeStyle, { globalSpacing } from '../../Theme/styles';

import Button from '../Button';
import ResponsiveText from '../ResponsiveText';

class FormFieldCheckbox extends React.Component {
  _getStatus() {
    const { formikProps, name, status } = this.props;
    const { errors } = formikProps;
    if (errors[name]) {
      return 'danger';
    } else {
      return status || 'success';
    }
  }

  render() {
    const { accessoryRight, formikProps, label, name, subLabel, ...rest } =
      this.props;
    const { setFieldTouched, setFieldValue, values, errors } = formikProps;
    return (
      <View
        style={[
          ThemeStyle.flex1,
          ThemeStyle.flexDirectionRowCenterSpaceBetween,
        ]}
        {...rest}
      >
        <Button
          style={[ThemeStyle.flex1, ThemeStyle.flexDirectionRowCenter]}
          onPress={() => {
            setFieldTouched(name);
            setFieldValue(name, !values[name]);
          }}
          plain
        >
          <CheckBox
            status={this._getStatus()}
            checked={values[name]}
            onChange={() => {
              setFieldTouched(name);
              setFieldValue(name, !values[name]);
            }}
            style={styles.checkboxStyle}
          />

          <View style={ThemeStyle.flex1}>
            <ResponsiveText
              category="label"
              status={errors[name] ? 'danger' : 'default'}
            >
              {label}
            </ResponsiveText>
            {!!subLabel && (
              <ResponsiveText
                category="c1"
                status={errors[name] ? 'danger' : 'default'}
              >
                {subLabel}
              </ResponsiveText>
            )}
          </View>
        </Button>

        {accessoryRight}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  checkboxStyle: {
    marginRight: globalSpacing / 2,
  },
});

FormFieldCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  subLabel: PropTypes.string,
  accessoryRight: PropTypes.any,
};

export default withFormik(FormFieldCheckbox);
